import { AxiosError } from 'axios';

export const MUTED_ERROR_MESSAGES = [
  'Network Error',
  'Network request failed',
  'User does not exist',
  'Incorrect username or password',
  'Failed to fetch'
];

export const MUTED_ERRORS_NAMES = ['UserNotFoundException'];

export const THROTTLED_ERROR_CODES = [401, 403];
export const THROTTLING_RATE = 0.1;

export const shouldLogError = (error: Error) => {
  return (
    !MUTED_ERROR_MESSAGES.some((mutedError) =>
      error.message?.toLowerCase().includes(mutedError.toLowerCase())
    ) && !MUTED_ERRORS_NAMES.includes(error.name)
  );
};

export const shouldThrottleError = (error: Error | AxiosError) => {
  if ('isAxiosError' in error && error.isAxiosError) {
    return (
      THROTTLED_ERROR_CODES.includes(error.response?.status ?? 0) &&
      Math.random() < THROTTLING_RATE
    );
  }
  return false;
};
